import { Col, Row } from "antd";
import React from "react";
import CodeSyntaxHighlighter from "../../../component/syntax-highlighter";

var html = `:root {
  /* the primary color */
  --wax-primary-color: #ff8474;

  /* the secondary color */
  --wax-secondary-color: #583d72;

  /* the font-family for all text */
  --wax-font-family: Arial, Helvetica, sans-serif;
  --wax-font-size--large: 18px;

  /* the default font size (best kept as is) */
  --wax-font-size: 14px;

  /* the smaller font size (best kept as is) */
  --wax-font-size--small: 12px;

  /* border radius for all roundings of inputs, buttons, images */
  --wax-radius: 8px;
  --wax-radius-small: 4px;

  /* border radius for card */
  --wax-radius-card: 8px;

  /* border color for buttons, inputs */
  --wax-border: #353945;
' '
  /* border color for the cards (if none use same color as card background) */
  --wax-border-card: #23262f;
  
  /* border thickness */
  --wax-border-size: 1px;

  /* color primary text */
  --wax-text-color: #fcfcfd;

  /* colors for non primary text */
  --wax-text-color-secondary: #777e90;

  /* filter button, buy button in the card (highlight) */
  --wax-btn-primary-bg: #23262f;
  --wax-btn-primary-border: #ff8474;
  --wax-btn-primary--active: #23262f;
  --wax-btn-primary-bg--active: #ff8474;
  --wax-btn-primary-border--active: #ff8474;

  /* backgrounds */
  /* list background in filters (schemas) */
  --wax-bg-list-item: #141416;

  /* all inputs (filters) */
  --wax-bg-inputs: #23262f;

  /* card background */
  --wax-bg-card: #23262f;
}`;

export default function Styling() {
  return (
    <Row gutter={[0, 40]}>
      <Col xs={24}>
        <h1>Styling</h1>
      </Col>
      <Col xs={24}>
        <CodeSyntaxHighlighter code={html} />
      </Col>
    </Row>
  );
}
